import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'portal-ui-pay-now-service',
  standalone: true,
  imports: [],
  templateUrl: './pay-now-service.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayNowServiceComponent {}
